import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Redirect } from "react-router";
import LoaderCircle from "../../loader/LoaderCircle";
import FormBuilder from "../../../class/tool/FormBuilder";
import ClientController from "../../../stories/_client/Clients/ClientController";
import "../../../css/form/Form.css";
import AddIcon from "../../icons/AddIcon";
import CrossIcon from "../../icons/CrossIcon";
import LessIcon from "../../icons/LessIcon";

const FormStart = props => {
    const item = "clients";
    const controller = new ClientController();

    const { object, handleIndex } = props;
    const [ reload, setReload ] = useState(false);
    const [ values, setValues ] = useState({});
    const [ errors, setErrors ] = useState([]);
    const [ saving, setSaving ] = useState(false);
    const [ globalError, setGlobalError ] = useState(null);
    const [ rows, setRows ] = useState([
        {
            label: "Genre",
            attribute: "gender",
            inputType: "select",
            returnType: "string",
            list: [
                {
                    value: "I"
                },
                {
                    value: "W"
                },
                {
                    value: "M"
                },
                {
                    value: "O"
                }
            ],
            dictionary: {
                "I": "Indifférent",
                "W": "Femme",
                "M": "Homme",
                "O": "Autre"
            },
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Nom",
            attribute: "lastname",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "Nom",
            emptyText: "Aucun"
        },
        {
            label: "Prénom",
            attribute: "firstname",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "Prénom",
            emptyText: "Aucun"
        },
        {
            label: "Mobile",
            attribute: "mobile",
            inputType: "phone",
            subType: "mobile",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Téléphone",
            attribute: "phone",
            inputType: "phone",
            subType: "phone",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Email",
            attribute: "email",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "Email",
            emptyText: "Aucune"
        }
    ]);
    const [ additionalRows, setAdditionalRows ] = useState([
        {
            label: "Adresse",
            attribute: "address",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "1 Rue du petit pont",
            emptyText: "Aucune"
        },
        {
            label: "Complément d'adresse",
            attribute: "additional",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Code postal",
            attribute: "postalCode",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Ville",
            attribute: "city",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Pays",
            attribute: "country",
            inputType: "select",
            returnType: "string",
            list: [
                {
                    "value": "Allemagne",
                    "id": 1
                },
                {
                    "value": "Autriche",
                    "id": 2
                },
                {
                    "value": "Belgique",
                    "id": 3
                },
                {
                    "value": "Espagne",
                    "id": 4
                },
                {
                    "value": "France",
                    "id": 5
                },
                {
                    "value": "Irlande",
                    "id": 6
                },
                {
                    "value": "Italie",
                    "id": 7
                },
                {
                    "value": "Luxembourg",
                    "id": 8
                },
                {
                    "value": "Portugal",
                    "id": 9
                },
                {
                    "value": "Royaume-Uni",
                    "id": 10
                },
                {
                    "value": "Suisse",
                    "id": 11
                }
            ],
            dictionary: null,
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Date de naissance",
            attribute: "birthday",
            inputType: "datePicker",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Délai de paiement",
            attribute: "paymentDelay",
            inputType: "select",
            returnType: "string",
            list: [
                {
                    value: 0
                },
                {
                    value: 15
                },
                {
                    value: 30
                },
                {
                    value: 45
                },
                {
                    value: 60
                }
            ],
            dictionary: {
                0: "Comptant",
                15: "15 jours",
                30: "30 jours",
                45:"45 jours",
                60:"60 jours"
            },
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        }
    ]);
    const [ seeMore, setSeeMore ] = useState(false);

    const initValues = () => {
        controller.setFormValues(object, setValues)
    }
    const handleChange = (attribute, returnType, val, strict = false) => {
        let value = FormBuilder.buildVal(returnType, val);
        let filtered = rows.filter(row => row.attribute === attribute && row.inputType === "select" && row.returnType === "int");
        let index = value;

        if (!strict && filtered.length > 0 && filtered[0].list.length > 0) {
            value = parseInt(filtered[0].list[index].id);

            if (filtered[0].list[index].type !== undefined && values[attribute.replace("_id", "_type")] !== undefined) {
                setValues(prev => ({
                    ...prev,
                    [attribute]: value,
                    [attribute.replace("_id", "_type")]: filtered[0].list[index].type
                }));
            }
            else {
                setValues(prev => ({
                    ...prev,
                    [attribute]: value
                }));
            }
        }
        else {
            filtered = rows.filter(row => row.attribute === attribute && row.inputType === "select" && row.returnType === "string")

            if (filtered.length > 0) {
                if (filtered[0].list.filter(_ => _.value === value && _.id !== undefined && _.id === null).length > 0)
                    value = null
            }

            setValues(prev => ({
                ...prev,
                [attribute]: value
            }))
        }
    }
    const callToSave = () => {
        setGlobalError(null)
        reinitAllEdits()
        save()
    }
    const reinitAllEdits = () => {
        setErrors([])
    }
    const returnUpdates = () => {
        return controller.returnUpdatesFromCompare(object, values);
    }
    const check422Errors = errorDatas => {
        setGlobalError("Certaines données sont invalides")

        if(errorDatas !== undefined) {
            let keys = Object.keys(errorDatas)
            let fields = ["reference"]

            for(let item in fields)
                if(keys.includes(fields[item]))
                    defineErrors(fields[item], false)
        }
    }
    const defineErrors = (type, empty) => {
        let errorsTmp = errors.slice()

        switch (type) {
            case "name":
                if(empty) errorsTmp["name"] = "Vous devez saisir un nom"
                else errorsTmp["name"] = "Ce nom n'est pas valide"
                break
            default: break
        }

        setErrors(errorsTmp)
    }
    const handleReturnSave = (response, error) => {
        if(error) {
            if(error.response !== undefined) {
                if(error.response.status === 422)
                    check422Errors(error.response.data);
            }
            else
                setGlobalError("Une erreur s'est produite lors de l'enregistrement");
        }
        else {
            setReload(true);
            handleIndex();
        }

        setSaving(false);
    }
    const save = () => {
        const datas = returnUpdates();

        if(Object.keys(datas).length === 0) return;

        setSaving(true);

        controller._callback = handleReturnSave;
        controller.post(datas);
    }
    const handleSubmit = event => {
        if (event !== undefined)
            event.preventDefault();

        callToSave();
    }
    const handleSeeMore = () => {
        setSeeMore(!seeMore);
    }

    useEffect(() => {
        initValues();
    }, []);

    return (
        <div className="clearing">
            {
                reload && <Redirect to={ "/" + item } />
            }
            <form className="form" onSubmit={handleSubmit}>
                {
                    globalError !== null && <p className="globalError">{globalError}</p>
                }
                {
                    rows.map((row, index) => (
                        <div key={ index } className="clearing">
                            <label className={ row.classnameLabel }>{ row.label }</label>
                            {
                                FormBuilder.buildInputByType(row, values, errors, handleChange, null, null, handleSubmit, null, null, null, index === 0)
                            }
                        </div>
                    ))
                }
                {
                    seeMore
                    && additionalRows.map((row, index) => (
                        <div key={ index } className="clearing">
                            <label className={ row.classnameLabel }>{ row.label }</label>
                            {
                                FormBuilder.buildInputByType(row, values, errors, handleChange, null, null, handleSubmit, null, null, null, false)
                            }
                        </div>
                    ))
                }
                {
                    additionalRows.length > 0
                    && <div className={"seeMore"} onClick={handleSeeMore}>
                        {
                            seeMore
                                ? <>
                                    <LessIcon />
                                    <p>Voir moins</p>
                                </>
                                : <>
                                    <CrossIcon />
                                    <p>Voir plus</p>
                                </>
                        }
                    </div>
                }
                <button className={"submit " + (saving ? "hide" : "")}>
                    {
                        saving
                            ? "Enregistrement..."
                            : "Enregistrer"
                    }
                    <LoaderCircle display="loader submitForm " hide={!saving ? "hide" : ""} strokeWidth="8" stroke="#FFFFFF" />
                </button>
                <Link to={ "/" + item }>
                    <button className="cancel align">Fermer</button>
                </Link>
                <div className="clearing" />
            </form>
        </div>
    )
}

export default FormStart;
